import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 h-16 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="w-full h-16 px-4 md:px-8 flex items-center justify-between gap-4">
        <button
          type="button"
          onClick={() => goTo("top")}
          className={`flex items-center gap-2.5 cursor-pointer ${scrolled ? "text-foreground-950" : "text-background-50"}`}
        >
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-book-open-line text-lg" />
          </span>
          <span className="flex flex-col items-start leading-none">
            <span className="font-heading text-base font-semibold whitespace-nowrap">年轻的岳母</span>
            <span className={`text-[10px] tracking-[0.18em] uppercase ${scrolled ? "text-foreground-500" : "text-background-200"}`}>
              Reading Scene
            </span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.id}
              type="button"
              onClick={() => goTo(link.id)}
              className={`px-3 py-2 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                  : "text-background-100 hover:text-background-50 hover:bg-foreground-950/20"
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => goTo("resources")}
            className="hidden md:inline-flex items-center gap-2 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-compass-3-line" />
            进入资源入口
          </button>
          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            aria-label="打开导航菜单"
            className={`lg:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled ? "text-foreground-950 bg-background-100" : "text-background-50 bg-foreground-950/25"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open ? (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => goTo(link.id)}
                className="text-left px-3 py-2.5 text-sm rounded-md bg-background-100 text-foreground-800 whitespace-nowrap cursor-pointer hover:text-primary-700"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}